






import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { mapActionsDvm } from '@/main/pages';

import { SMLUVNI_PARTNER_TYP } from '../../constants';
import { isVozidloSet } from '../../utils';
import { store } from '../../store/edit';


export default Vue.extend({
	name: 'ZakazkaSmluvniPartnerTypSelect',
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		SmluvniPartnerTypListWithDisabledFields(): any {
			return this.dropdownList.SmluvpartnerPzn.map((smluvniPartnerTyp: object) => this.setDisabled(smluvniPartnerTyp, this.ZakazkaDruh, this.VozidloId));
		},
	},
	watch: {
		SmluvpartnerPzn() {
			if (!this.loading) {
				this.smluvniPartnerTypChange();
			}
		},
	},
	methods: {
		...mapActionsDvm(store.actions),

		setDisabled(smluvniPartnerTyp: any, zakazkaDruh: any, vozidloId: number | null): any {
			if (smluvniPartnerTyp.Value === SMLUVNI_PARTNER_TYP.LEASING_FIRMA) {
				smluvniPartnerTyp.disabled = !isVozidloSet(zakazkaDruh, vozidloId!);
			}
			return smluvniPartnerTyp;
		},
	},
});
